import { Injectable } from '@angular/core';
import * as crypto from 'crypto-js';
import { environment } from '../../environments/environment';
import { Rol } from '../models/rol';
import { User } from '../models/user';
import { LocalstorageService } from './local.storage.service';

@Injectable({
  providedIn: 'root'
})
export class LocalService {

  constructor(private localStorage: LocalstorageService ) { }


  getLocal(id: string): any {
    let data = this.localStorage.getItem(id);
    // istanbul ignore if
    if (environment.production) {
      if (data) {
        data = crypto.AES.decrypt(data, 'newagora').toString(crypto.enc.Utf8);
      }
    }
    // @ts-ignore
    return data === undefined ? undefined : JSON.parse(data);
  }

  setLocal(id: string, obj: string | Rol[] | User) {
    let data = JSON.stringify(obj);
    // istanbul ignore if
    if (environment.production) {
      data = crypto.AES.encrypt(data, 'newagora').toString();
    }
    this.localStorage.setItem(id, data);
  }

  cleanLocal(id: string) {
    this.localStorage.removeItem(id);
  }

}
